import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function TopBar({ title, onBack, right, testIdBack = "top-back-btn" }) {
  const navigate = useNavigate();
  const back = onBack || (() => navigate(-1));
  return (
    <div className="top-bar">
      <button
        type="button"
        className="icon-btn"
        onClick={back}
        aria-label="Back"
        data-testid={testIdBack}
      >
        <ArrowLeft size={18} />
      </button>
      <div className="tiny" style={{ letterSpacing: "0.22em" }}>{title}</div>
      <div style={{ width: 40, display: "flex", justifyContent: "flex-end" }}>{right}</div>
    </div>
  );
}
